module.exports = __webpack_public_path__ + "static/Screenshot (60)-054cffb3f9d4a9037c37f20300236b32.png";